export const getPasswordInputType = ({
  isVisible,
  isTemporarilyRevealing,
}: {
  isVisible: boolean;
  isTemporarilyRevealing: boolean;
}): "text" | "password" =>
  isVisible || isTemporarilyRevealing ? "text" : "password";

export const shouldTemporarilyRevealPassword = ({
  revealWhileTyping,
  isVisible,
}: {
  revealWhileTyping: boolean;
  isVisible: boolean;
}): boolean => revealWhileTyping && !isVisible;

export const getPasswordToggleLabel = (isVisible: boolean): string =>
  isVisible ? "Hide password" : "Show password";
